import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import queries from './queries';

export const getFacilityTariffs = async (facilityId, meterTypeId) => {
  return await request.get(
    `/RentPlace/rental_house/${facilityId}/tariff`,
    { meterTypeId },
    'При загрузке тарифов объекта произошла ошибка',
    []
  );
};

const useFacilityTariffs = (facilityId, meterTypeId, enabled = !!facilityId, options = {}) =>
  useQuery(
    [queries.facilityTariffs, facilityId, meterTypeId],
    () => getFacilityTariffs(facilityId, meterTypeId),
    {
      placeholderData: [],
      enabled,
      ...options
    }
  );

export default useFacilityTariffs;
